import {
    ethers
} from 'ethers'
import store from '../store/index.js'
import {
    createClient
} from '@layerzerolabs/scan-client';

var TransStatusRequest = /*#__PURE__*/ function () {
    function TransStatusRequest(txhash, type, callback) {
        this.txHash = txhash;
        this.type = type;
        this.callback = callback;
    }
    return TransStatusRequest;
}();

class HashStatusObserve {
    constructor() {
        this.txHashArray = [];
        this.timer = null
    }

    subscribe(transStatusRequest) {
        var txHash = transStatusRequest.txHash
        if (!txHash) {
            return
        }

        this.txHashArray.push(transStatusRequest)
        if (this.txHashArray.length > 0) {
            if (!this.timer) {

                if (transStatusRequest.type == 'layerZero') {
                    getCrossChainStatus(this.txHashArray)
                    this.timer = setInterval(() => {
                        getCrossChainStatus(this.txHashArray)
                    }, 1500)
                } else {
                    getTransStatus(this.txHashArray)
                    this.timer = setInterval(() => {
                        getTransStatus(this.txHashArray)
                    }, 1500)
                }

            }
        } else {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null
            }
        }

    }

    notify(txHash, status) {
        for (let i = 0; i < this.txHashArray.length; i++) {
            let request = this.txHashArray[i]
            if (txHash == request.txHash) {
                var fn = request.callback
                fn.call(this, {
                    txHash,
                    status
                })
            }
        }
    }

    notifyLayerZero(txHash, message) {
        for (let i = 0; i < this.txHashArray.length; i++) {
            let request = this.txHashArray[i]
            if (txHash == request.txHash) {
                var fn = request.callback
                fn.call(this, {
                    txHash,
                    message
                })
            }
        }
    }


    //
    unsubscribe(transStatusRequest) {
        var txHash = transStatusRequest.txHash
        for (let i = 0; i < this.txHashArray.length; i++) {
            let request = this.txHashArray[i]
            if (txHash == request.txHash) {
                this.txHashArray.splice(i, 1)
            }
        }
        if (this.txHashArray.length <= 0) {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null
            }
        }
    }
}

function getTransStatus(txHashArray) {
    let webProvider = new ethers.providers.Web3Provider(store.state.provider)

    for (let i = 0; i < txHashArray.length; i++) {
        let request = txHashArray[i]
        let txHash = request.txHash
        webProvider.getTransactionReceipt(txHash).then((r) => {
            if (r) {
                if (r.status != null) {
                    txHashStatusObserveManager.notify(txHash, r.status)
                }
            }
        })
        //do getstatus
    }

}


function getCrossChainStatus(txHashArray) {

    let net = process.env.VUE_APP_RUNTIME_ENV === 'production' ? 'mainnet' : 'testnet'
    const client = createClient(net);

    for (let i = 0; i < txHashArray.length; i++) {
        let request = txHashArray[i]
        let txHash = request.txHash

        client.getMessagesBySrcTxHash(txHash).then((result) => {
            if (result && result.messages) {
                txHashStatusObserveManager.notifyLayerZero(txHash, result.messages[0])
            }

        }).catch(err => {
            //console.log('getMessagesBySrcTxHash.err',err);

        });

        //do getstatus
    }

}

const txHashStatusObserveManager = new HashStatusObserve()

// export default txHashStatusObserveManager

// export { TransStatusRequest };

/**
 * * Enable subscription
 */
function enableSubscription(txhash, type, callback) {
    var getTxHashStatus = new TransStatusRequest(txhash, type, callback)
    //订阅
    txHashStatusObserveManager.subscribe(getTxHashStatus);

    return getTxHashStatus
}


export function getTransferStatus(txHash) {
    return new Promise((resolve) => {
        let request = enableSubscription(txHash, '', callback => {
            txHashStatusObserveManager.unsubscribe(request);
            resolve(callback)
        })
    });
}


export function getCrossChainTransferStatus(txHash, callback) {
    var getCrossStatus = new TransStatusRequest(txHash, 'layerZero', callback)
    //订阅
    txHashStatusObserveManager.subscribe(getCrossStatus);

    return getCrossStatus
}

export function stopGetCrossChainStatus(request) {
    txHashStatusObserveManager.unsubscribe(request);
}